import apiSkobo from "@/helpers/api/apiSkobo";

export const relations_actions = {
  async loadUsersRelations(userId) {
    if (this.userRelations[userId]) {
      return;
    }
    await this.reloadUsersRelations(userId);
  },

  async reloadUsersRelations(userId) {
    const response = await apiSkobo.get(`/appconfidentialfolder/userrelations/${userId}`);

    const clone = JSON.parse(JSON.stringify(this.userRelations));
    clone[userId] = response.data;
    this.userRelations = clone;
  }
};

export const relations_getters = {
  usersRelations(state) {
    return userId => {
      return state.userRelations[userId];
    };
  }
};

export const relations_state = {
  userRelations: {}
};
